// extracted by mini-css-extract-plugin
export default {"history-div":"history_history-div__Z+ssM","history-category":"history_history-category__06ERS","history-info":"history_history-info__nB6KI","children":"history_children__u9SOo"};